<section
  id="top-bar"
  class="bg-base-100 border-b border-base-200 z-50 flex justify-between items-center w-full px-6 h-20 min-h-20 transition-all select-none">
  <div class="flex items-center gap-2">
    @if (parentHeader()) {
      <span class="font-medium text-base-content/40 text-lg">{{ parentHeader() }}</span>
      <span class="icon-[mdi--chevron-right] text-base-content/20"></span>
    }
    <h1 class="text-lg font-bold text-base-content tracking-tight">{{ header() }}</h1>
  </div>
  <ng-container *ngTemplateOutlet="suffixSection" />
</section>

<ng-template #suffixSection>
  @if (user(); as user) {
    <div class="flex items-center gap-1">
      <a routerLink="/my-page" class="btn btn-ghost gap-2 text-base-content">
        @if (user.profileImageUrl) {
          <img [src]="user.profileImageUrl" alt="프로필" class="size-7 rounded-full object-cover" />
        } @else {
          <span class="icon-[mdi--account-circle] text-xl"></span>
        }
        <span class="text-sm">{{ user.name }}</span>
      </a>
      <div class="w-px h-6 bg-base-300 mx-1"></div>
      <button (click)="logout()" class="btn btn-ghost gap-1.5 text-base-content">
        <span class="icon-[mdi--logout] text-xl"></span>
        <span class="text-sm">로그아웃</span>
      </button>
    </div>
  }
</ng-template>
